import { Component, Vue, Prop } from 'vue-property-decorator';

import { ImageResourceDTO } from '../../model/ImageResourceDTO';
import { GalleryCrossFadingImagesItem } from '../gallery-cross-fading-images-item/gallery-cross-fading-images-item';


@Component({
	components: {
		GalleryCrossFadingImagesItem
	}
})
export class GalleryCrossFadingImages extends Vue {
	@Prop() items: ImageResourceDTO[][];
	@Prop() sizes: string;
	@Prop() itemsPerView?: number[];
	@Prop() description: boolean;

	
}

export default GalleryCrossFadingImages;
